import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type {
  IbhPartsResponseDto,
  IbhPartsRequestDto,
  IbhSimilarPartsLightParams,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import * as Sentry from '@sentry/nextjs';

export const fetchSimilarParts = async (
  query: IbhSimilarPartsLightParams,
  data: IbhPartsRequestDto
): Promise<IbhPartsResponseDto[]> => {
  try {
    ibhApiService.abortRequest('similarPartsLight');
    const response = await ibhApiService.similarPartsLight(query, data, { cancelToken: 'similarPartsLight' });
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(`Cannot fetch parts for given data: ${JSON.stringify(data)}`);
  }
};
